import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import {
  ApplePayCreditCardNetworks as ApplePayCreditCardNetworksServer,
  type MerchantCapability as MerchantCapabilityServer,
  type IApplePayPaymentMethod as IApplePayPaymentMethodServer,
} from '@wix/cashier-core/dist/src/services/PaymentMethod/types';
import { ApplePayCreditCardNetworks, type ApplePayPaymentMethod } from '../../../types/PaymentMethods';

const ApplePayCreditCardNetworksMap: Record<ApplePayCreditCardNetworksServer, ApplePayCreditCardNetworks> = {
  [ApplePayCreditCardNetworksServer.Amex]: ApplePayCreditCardNetworks.Amex,
  [ApplePayCreditCardNetworksServer.CartesBancaires]: ApplePayCreditCardNetworks.CartesBancaires,
  [ApplePayCreditCardNetworksServer.ChinaUnionPay]: ApplePayCreditCardNetworks.ChinaUnionPay,
  [ApplePayCreditCardNetworksServer.Discover]: ApplePayCreditCardNetworks.Discover,
  [ApplePayCreditCardNetworksServer.Eftpos]: ApplePayCreditCardNetworks.Eftpos,
  [ApplePayCreditCardNetworksServer.Electron]: ApplePayCreditCardNetworks.Electron,
  [ApplePayCreditCardNetworksServer.Elo]: ApplePayCreditCardNetworks.Elo,
  [ApplePayCreditCardNetworksServer.Interac]: ApplePayCreditCardNetworks.Interac,
  [ApplePayCreditCardNetworksServer.Jcb]: ApplePayCreditCardNetworks.Jcb,
  [ApplePayCreditCardNetworksServer.Mada]: ApplePayCreditCardNetworks.Mada,
  [ApplePayCreditCardNetworksServer.Maestro]: ApplePayCreditCardNetworks.Maestro,
  [ApplePayCreditCardNetworksServer.MasterCard]: ApplePayCreditCardNetworks.MasterCard,
  [ApplePayCreditCardNetworksServer.PrivateLabel]: ApplePayCreditCardNetworks.PrivateLabel,
  [ApplePayCreditCardNetworksServer.Visa]: ApplePayCreditCardNetworks.Visa,
  [ApplePayCreditCardNetworksServer.VPAY]: ApplePayCreditCardNetworks.VPAY,
};

const ApplePayMerchantCapabilitiesMap: Record<MerchantCapabilityServer, ApplePayJS.ApplePayMerchantCapability> = {
  SUPPORTS_3DS: 'supports3DS',
  SUPPORTS_EMV: 'supportsEMV',
  SUPPORTS_CREDIT: 'supportsCredit',
  SUPPORTS_DEBIT: 'supportsDebit',
};

function mapSupportedNetworksToCommon(
  supportedNetworks: ApplePayCreditCardNetworksServer[],
): ApplePayCreditCardNetworks[] {
  return supportedNetworks && supportedNetworks.map((value) => ApplePayCreditCardNetworksMap[value]);
}

function mapMerchantCapabilitiesToCommon(
  merchantCapabilities: MerchantCapabilityServer[],
): ApplePayJS.ApplePayMerchantCapability[] {
  return merchantCapabilities && merchantCapabilities.map((value) => ApplePayMerchantCapabilitiesMap[value]);
}

export function mapApplePayPaymentMethodToCommon(paymentMethod: IApplePayPaymentMethodServer): ApplePayPaymentMethod {
  const { merchantCountry, supportedNetworks, merchantCapabilities } = paymentMethod[PaymentMethod.ApplePay];

  return {
    ...paymentMethod,
    [PaymentMethod.ApplePay]: {
      merchantCountry,
      supportedNetworks: mapSupportedNetworksToCommon(supportedNetworks),
      merchantCapabilities: mapMerchantCapabilitiesToCommon(merchantCapabilities),
    },
  };
}
